import { lazy, Suspense, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { closeDialog } from "../../redux/reducer/dialogSlice";
import { AppBar, Dialog, IconButton, Toolbar, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import PageLoader from "../loader/LoaderText";

const HospitalPage = lazy(() => import("./hospital"));
const SchemePage = lazy(() => import("./schemes"));
const UserPage = lazy(() => import("./users"));

const dialogComponents: Record<string, React.LazyExoticComponent<React.FC>> = {
    hospital: HospitalPage,
    scheme: SchemePage,
    user: UserPage
};

const CommonDialogComponent = () => {
    const dispatch = useDispatch();
    const { isOpen, isFullScreen, title, size, moduleType } = useSelector((state: RootState) => state.dialog);

    const handleClose = useCallback(() => {
        dispatch(closeDialog());
    }, [dispatch]);
    const DialogComponent = moduleType ? dialogComponents[moduleType] : null;

    return (
        <Dialog
            open={isOpen}
            BackdropProps={{
                sx: {
                    backdropFilter: 'blur(2px) sepia(8%)',
                    backgroundColor: 'rgba(0, 0, 0, 0.51)',
                },
              }}
            fullScreen={isFullScreen}
            fullWidth
            maxWidth={(size as 'xs' | 'sm' | 'md' | 'lg' | 'xl') ?? 'md'}
            PaperProps={{
                sx: {
                    borderRadius: isFullScreen ? 0 : 2,
                    boxShadow: 4,
                    overflowY: 'unset',
                },
            }}
        >
            {isFullScreen && <AppBar elevation={7} sx={{ position: 'relative', height: '59px' }}>
                <Toolbar sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography sx={{ flex: 1 }} variant="h5" fontWeight={"h4.fontWeight"} component="div">{title}</Typography>
                    <IconButton edge="start" color="inherit" onClick={handleClose}> <CloseIcon /> </IconButton>
                </Toolbar>
            </AppBar>}

            <Suspense fallback={<PageLoader />}>
                {DialogComponent ? <DialogComponent /> : null}
            </Suspense>

        </Dialog>
    )
}
export default CommonDialogComponent